// ERZEUGT aus lib/pricing.js durch scripts/gen-pricing-twin.cjs — nicht von Hand ändern.
// lib/pricing.js — Preise und Leistungen eines Platzes (v2, 2026-10-20, docs/superpowers/specs/2026-10-20-preise-design.md).
// Rein: Prüfung (Server), Migration aus v1, aktuelle Saison, Beispielrechnung, Vorlagen, Saisonleiste.
// Zwilling für die Oberflächen: src/shared/pricing.js (Gleichheitstest test/pricing-twin.test.mjs).

const SEASON_KINDS = ['high', 'mid', 'low', 'custom'];
const PITCH_KINDS = ['vehicle', 'tent', 'comfort', 'custom'];
const ELECTRICITY_MODES = ['night', 'kwh', 'flat_kwh'];
const SERVICES = ['shower', 'wifi', 'disposal', 'washing', 'dryer', 'bread', 'visitor', 'dog_shower', 'beach'];
const SERVICE_UNITS = ['piece', 'night', 'stay', 'day'];
const ACSI_RATES = [13, 15, 17, 19, 21, 23, 25, 27];
const MAX = { seasons: 4, ranges: 4, pitches: 4, children: 3, long_stay: 3, price: 9999, name: 40 };
const DIM = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

const num = (v) => {
  if (v === null || v === undefined || v === '') return null;
  const n = typeof v === 'number' ? v : Number(String(v).trim().replace(',', '.'));
  return Number.isFinite(n) ? n : NaN;
};
const round2 = (n) => Math.round(n * 100) / 100;
const int = (v, lo, hi) => { const n = num(v); return n === null ? null : Number.isInteger(n) && n >= lo && n <= hi ? n : NaN; };
const line = (v) => String(v == null ? '' : v).replace(/\s+/g, ' ').trim().slice(0, MAX.name);
const md = (s) => { const m = /^(\d{2})-(\d{2})$/.exec(String(s || '')); if (!m) return null; const mo = +m[1], d = +m[2]; return mo >= 1 && mo <= 12 && d >= 1 && d <= DIM[mo - 1] ? mo * 100 + d : null; };
const has = (o) => o && Object.keys(o).length > 0;

/** Liegt das Datum in einer der Spannen der Saison? (jährlich, auch über den Jahreswechsel) */
function inSeason(season, date) {
  const x = (date.getMonth() + 1) * 100 + date.getDate();
  return (season.ranges || []).some((r) => { const a = md(r.from), b = md(r.to); if (a == null || b == null) return false; return a <= b ? x >= a && x <= b : x >= a || x <= b; });
}
/** Aktuelle Saison: ohne Saisons { id: 'all' }; außerhalb aller Spannen null. */
function seasonAt(p, date = new Date()) {
  const seasons = (p && p.seasons) || [];
  if (!seasons.length) return { id: 'all', kind: 'all' };
  return seasons.find((s) => inSeason(s, date)) || null;
}

function validate(input, today) {
  const errors = [], b = input && typeof input === 'object' ? input : {};
  const out = { v: 2, updated: today, seasons: [] };
  const seasons = Array.isArray(b.seasons) ? b.seasons : [];
  if (seasons.length > MAX.seasons) errors.push('seasons');
  for (const s of seasons.slice(0, MAX.seasons)) {
    if (!s || !/^s[1-9]$/.test(s.id)) { errors.push('season_id'); continue; }
    if (!SEASON_KINDS.includes(s.kind)) { errors.push('season_kind'); continue; }
    const ranges = Array.isArray(s.ranges) ? s.ranges : [];
    if (ranges.length > MAX.ranges) errors.push('season_range');
    const rs = [];
    for (const r of ranges.slice(0, MAX.ranges)) { if (md(r && r.from) == null || md(r && r.to) == null) errors.push('season_range'); else rs.push({ from: r.from, to: r.to }); }
    const o = { id: s.id, kind: s.kind, ranges: rs };
    if (s.kind === 'custom') o.name = line(s.name);
    out.seasons.push(o);
  }
  const keys = out.seasons.length ? out.seasons.map((s) => s.id) : ['all'];
  const prices = (src) => {
    const o = {};
    for (const k of keys) { const v = num(src && src[k]); if (v === null) continue; if (!(v >= 0 && v <= MAX.price)) errors.push('price'); else o[k] = round2(v); }
    return o;
  };
  out.pitches = [];
  const pitches = Array.isArray(b.pitches) ? b.pitches : [];
  if (pitches.length > MAX.pitches) errors.push('pitches');
  for (const p of pitches.slice(0, MAX.pitches)) {
    if (!p || !/^p[1-9]$/.test(p.id) || !PITCH_KINDS.includes(p.kind)) { errors.push('pitch'); continue; }
    const persons = int(p.persons ?? 0, 0, 8);
    if (Number.isNaN(persons)) { errors.push('pitch_persons'); continue; }
    const o = { id: p.id, kind: p.kind, persons: persons || 0, prices: prices(p.prices) };
    if (p.kind === 'custom') o.name = line(p.name);
    if (has(o.prices)) out.pitches.push(o);
  }
  const adult = prices(b.adult && b.adult.prices);
  if (has(adult)) out.adult = { prices: adult };
  out.children = [];
  const children = Array.isArray(b.children) ? b.children : [];
  if (children.length > MAX.children) errors.push('children');
  for (const c of children.slice(0, MAX.children)) {
    const from = int(c && c.from, 0, 17), to = int(c && c.to, 0, 17);
    if (Number.isNaN(from) || Number.isNaN(to) || (from != null && to != null && from > to)) { errors.push('child_age'); continue; }
    const ps = prices(c && c.prices);
    if (has(ps)) out.children.push({ from, to, prices: ps });
  }
  const pet = prices(b.pet && b.pet.prices);
  if (has(pet)) out.pet = { prices: pet };
  if (b.electricity && num(b.electricity.price) !== null) {
    const e = b.electricity, price = num(e.price);
    if (!ELECTRICITY_MODES.includes(e.mode)) errors.push('electricity_mode');
    else if (!(price >= 0 && price <= MAX.price)) errors.push('price');
    else {
      const o = { mode: e.mode, price: round2(price) };
      if (e.mode === 'flat_kwh') {
        const inc = int(e.kwh_included, 1, 100), kp = num(e.kwh_price);
        if (inc === null || Number.isNaN(inc)) errors.push('kwh_included'); else o.kwh_included = inc;
        if (kp !== null) { if (!(kp >= 0 && kp <= 10)) errors.push('price'); else o.kwh_price = round2(kp); }
      }
      out.electricity = o;
    }
  }
  if (b.tourist_tax && num(b.tourist_tax.price) !== null) {
    const price = num(b.tourist_tax.price), fu = int(b.tourist_tax.free_until, 0, 17);
    if (!(price >= 0 && price <= 100)) errors.push('price');
    else if (Number.isNaN(fu)) errors.push('free_until');
    else out.tourist_tax = fu == null ? { price: round2(price) } : { price: round2(price), free_until: fu };
  }
  out.services = {};
  for (const [k, s] of Object.entries((b.services && typeof b.services === 'object') ? b.services : {})) {
    if (!SERVICES.includes(k)) { errors.push('service'); continue; }
    if (!s || !['included', 'paid'].includes(s.status)) continue; // „—“ = nicht angeboten
    const o = { status: s.status };
    if (s.status === 'paid') {
      const p = num(s.price);
      if (p !== null) { if (!(p >= 0 && p <= MAX.price)) { errors.push('price'); continue; } o.price = round2(p); }
      if (s.unit != null && s.unit !== '') { if (!SERVICE_UNITS.includes(s.unit)) { errors.push('service_unit'); continue; } o.unit = s.unit; }
    }
    out.services[k] = o;
  }
  out.rules = {};
  const r = (b.rules && typeof b.rules === 'object') ? b.rules : {};
  const mn = int(r.min_nights, 1, 60);
  if (Number.isNaN(mn)) errors.push('min_nights'); else if (mn != null) out.rules.min_nights = mn;
  if (r.acsi != null && r.acsi !== '') { const a = num(r.acsi); if (!ACSI_RATES.includes(a)) errors.push('acsi'); else out.rules.acsi = a; }
  const ls = Array.isArray(r.long_stay) ? r.long_stay : [];
  if (ls.length > MAX.long_stay) errors.push('long_stay');
  const lsOut = [];
  for (const x of ls.slice(0, MAX.long_stay)) { const n = int(x && x.nights, 2, 365), pc = int(x && x.percent, 1, 50); if (n == null && pc == null) continue; if (!n || !pc || Number.isNaN(n) || Number.isNaN(pc)) errors.push('long_stay'); else lsOut.push({ nights: n, percent: pc }); }
  if (lsOut.length) out.rules.long_stay = lsOut.sort((a, c) => a.nights - c.nights);
  const content = out.pitches.length || out.adult || out.children.length || out.pet || out.electricity || out.tourist_tax || has(out.services) || has(out.rules);
  return { ok: errors.length === 0, errors: [...new Set(errors)], data: content ? out : null };
}

/** v1 (flach) → v2; v2 und null unverändert. */
function migrate(p) {
  if (!p || typeof p !== 'object' || p.v === 2) return p;
  // Rohwerte durchreichen (auch „18,50“ oder Tippfehler) — die Prüfung entscheidet, nicht die Migration
  const all = (v) => ({ all: typeof v === 'number' ? v : (Number.isFinite(num(v)) ? num(v) : v) });
  const ok = (v) => num(v) !== null;
  const out = { v: 2, updated: p.updated || null, seasons: [],
    pitches: ok(p.pitch) ? [{ id: 'p1', kind: 'vehicle', persons: 0, prices: all(p.pitch) }] : [] };
  if (ok(p.adult)) out.adult = { prices: all(p.adult) };
  out.children = ok(p.child) ? [{ from: null, to: null, prices: all(p.child) }] : [];
  if (ok(p.pet)) out.pet = { prices: all(p.pet) };
  if (ok(p.electricity)) out.electricity = { mode: p.electricity_unit === 'kwh' ? 'kwh' : p.electricity_unit && p.electricity_unit !== 'night' ? p.electricity_unit : 'night', price: all(p.electricity).all };
  if (ok(p.tourist_tax)) out.tourist_tax = { price: all(p.tourist_tax).all };
  out.services = {}; out.rules = {};
  return out;
}

/** Beispielrechnung „2 Erwachsene + Wohnmobil, 1 Nacht“ für eine Saison. null, wenn ein nötiger Preis fehlt. */
function example(p, sid) {
  if (!p || !sid) return null;
  const pitch = (p.pitches || []).find((x) => x.kind === 'vehicle' && x.prices[sid] != null) || (p.pitches || []).find((x) => x.kind !== 'tent' && x.prices[sid] != null);
  if (!pitch) return null;
  const parts = [{ key: 'pitch', pitch: pitch.id, amount: pitch.prices[sid] }], notes = [];
  const extra = Math.max(0, 2 - (pitch.persons || 0));
  if (extra) {
    const a = p.adult && p.adult.prices[sid];
    if (a == null) return null;
    parts.push({ key: 'adults', count: extra, amount: a * extra });
  }
  const e = p.electricity;
  if (e) { if (e.mode === 'kwh') notes.push('electricity_kwh'); else parts.push({ key: 'electricity', amount: e.price }); }
  if (p.tourist_tax) parts.push({ key: 'tourist_tax', count: 2, amount: p.tourist_tax.price * 2 });
  const cents = parts.reduce((s, x) => s + Math.round(x.amount * 100), 0);
  return { total: cents / 100, parts, notes };
}

const TEMPLATES = {
  campsite: () => ({
    seasons: [
      { id: 's1', kind: 'high', ranges: [{ from: '07-01', to: '08-31' }] },
      { id: 's2', kind: 'mid', ranges: [{ from: '05-01', to: '06-30' }, { from: '09-01', to: '09-30' }] },
      { id: 's3', kind: 'low', ranges: [{ from: '10-01', to: '04-30' }] },
    ],
    pitches: [{ id: 'p1', kind: 'vehicle', persons: 2, prices: { s1: '', s2: '', s3: '' } }, { id: 'p2', kind: 'tent', persons: 2, prices: { s1: '', s2: '', s3: '' } }],
    adult: { prices: { s1: '', s2: '', s3: '' } },
    children: [{ from: 0, to: 5, prices: { s1: 0, s2: 0, s3: 0 } }, { from: 6, to: 15, prices: { s1: '', s2: '', s3: '' } }],
    pet: { prices: { s1: '', s2: '', s3: '' } },
    electricity: { mode: 'night', price: '' },
    tourist_tax: { price: '', free_until: 15 },
    services: { shower: { status: 'included' }, wifi: { status: 'included' }, disposal: { status: 'included' }, washing: { status: 'paid', unit: 'piece' }, dryer: { status: 'paid', unit: 'piece' }, bread: { status: 'paid' } },
    rules: {},
  }),
  stopover: () => ({
    seasons: [],
    pitches: [{ id: 'p1', kind: 'vehicle', persons: 2, prices: { all: '' } }],
    adult: { prices: { all: '' } },
    electricity: { mode: 'kwh', price: '' },
    tourist_tax: { price: '' },
    services: { disposal: { status: 'paid', unit: 'stay' }, shower: { status: 'paid', unit: 'piece' } },
    rules: {},
  }),
};
/** Startvorlage für den Editor (Preise leer, Struktur fertig). Die Children-Bänder mit 0 € zählen als Inhalt → Prüfung ok. */
function template(kind) { return TEMPLATES[kind] ? TEMPLATES[kind]() : null; }

/** 12-Monats-Leiste (Nicht-Schaltjahr, 365 Tage): zusammenhängende Abschnitte [{ season: id|null, start, len }]. */
function seasonBar(p) {
  const out = [];
  const d = new Date(2025, 0, 1);
  for (let i = 0; i < 365; i++, d.setDate(d.getDate() + 1)) {
    const s = ((p && p.seasons) || []).find((x) => inSeason(x, d));
    const id = s ? s.id : null;
    if (out.length && out[out.length - 1].season === id) out[out.length - 1].len++;
    else out.push({ season: id, start: i, len: 1 });
  }
  return out;
}

const amt = (v) => (v === null || v === undefined || v === '' || !Number.isFinite(Number(v)) ? null : Number(v));

/** Anzeige für Camper: Saisons mit Zeilen (aktuelle markiert, offen = aktuelle oder sonst die erste), Beispiel je Saison,
 *  Strom/Kurtaxe, Leistungen, Regeln. Nimmt auch v1 (wird migriert). null ohne Inhalt. */
function view(input, date = new Date()) {
  const p = migrate(input);
  if (!p || typeof p !== 'object') return null;
  const seasons = p.seasons && p.seasons.length ? p.seasons : [{ id: 'all', kind: 'all', ranges: [] }];
  const cur = seasonAt(p, date);
  const rowsFor = (sid) => {
    const rows = [];
    for (const x of p.pitches || []) { const a = amt(x.prices && x.prices[sid]); if (a != null) rows.push({ key: 'pitch', kind: x.kind, name: x.name || null, persons: x.persons || 0, amount: a }); }
    const ad = amt(p.adult && p.adult.prices && p.adult.prices[sid]);
    if (ad != null) rows.push({ key: 'adult', extra: (p.pitches || []).some((x) => x.persons > 0), amount: ad });
    for (const c of p.children || []) { const a = amt(c.prices && c.prices[sid]); if (a != null) rows.push({ key: 'child', from: c.from ?? null, to: c.to ?? null, amount: a }); }
    const pe = amt(p.pet && p.pet.prices && p.pet.prices[sid]);
    if (pe != null) rows.push({ key: 'pet', amount: pe });
    return rows;
  };
  const list = seasons.map((s) => ({ id: s.id, kind: s.kind, name: s.name || null, ranges: s.ranges || [], current: !!cur && cur.id === s.id, rows: rowsFor(s.id), example: example(p, s.id) }))
    .filter((s) => s.rows.length);
  const openIdx = Math.max(0, list.findIndex((s) => s.current));
  list.forEach((s, i) => { s.open = i === openIdx; });
  const sv = p.services || {};
  const services = {
    included: SERVICES.filter((k) => sv[k] && sv[k].status === 'included'),
    paid: SERVICES.filter((k) => sv[k] && sv[k].status === 'paid').map((k) => ({ key: k, price: amt(sv[k].price), unit: sv[k].unit || null })),
  };
  const e = p.electricity && amt(p.electricity.price) != null ? p.electricity : null;
  const tax = p.tourist_tax && amt(p.tourist_tax.price) != null ? p.tourist_tax : null;
  const rules = p.rules || {};
  if (!list.length && !e && !tax && !services.included.length && !services.paid.length && !has(rules)) return null;
  return { updated: p.updated || null, current: cur ? cur.id : null, seasons: list, electricity: e, tourist_tax: tax, services, rules };
}

/** Lokalisierte Texte zu view(): t(key, vars) übersetzt (Gruppe „price“), money(n) formatiert Euro, md('MM-DD') ein Tagesdatum.
 *  Liefert nur Zeichenketten — Escapen und Markup macht der Aufrufer. */
function describe(v, { t, money, md }) {
  if (!v) return null;
  const T = (k, vars) => t('price.' + k, vars);
  const seasonTitle = (s) => (s.kind === 'custom' ? s.name || T('season_custom') : T('season_' + s.kind));
  const childLabel = (c) => (c.from != null && c.to != null ? T('child_range', { from: c.from, to: c.to })
    : c.to != null ? T('child_until', { to: c.to }) : c.from != null ? T('child_from', { from: c.from }) : T('child'));
  const row = (r) => {
    if (r.key === 'pitch') return { label: r.kind === 'custom' ? r.name || T('pitch_custom') : T('pitch_' + r.kind), sub: r.persons ? T('pitch_persons', { n: r.persons }) : '', value: money(r.amount), per: T('per_night') };
    if (r.key === 'adult') return { label: T(r.extra ? 'adult_extra' : 'adult'), sub: '', value: money(r.amount), per: T('per_person_night') };
    if (r.key === 'child') return { label: childLabel(r), sub: '', value: r.amount === 0 ? T('free') : money(r.amount), per: r.amount === 0 ? '' : T('per_person_night') };
    return { label: T('pet'), sub: '', value: money(r.amount), per: T('per_night') };
  };
  const seasons = v.seasons.map((s) => ({
    id: s.id, current: s.current, open: s.open, title: s.kind === 'all' ? T('season_all') : seasonTitle(s),
    ranges: s.ranges.map((r) => T('range', { from: md(r.from), to: md(r.to) })).join(', '),
    rows: s.rows.map(row),
    example: s.example ? { title: T('example_title'), total: money(s.example.total),
      detail: s.example.parts.map((x) => (x.key === 'adults' ? T('ex_adults', { n: x.count }) : T('ex_' + x.key)) + ' ' + money(x.amount)).join(' + '),
      note: s.example.notes.includes('electricity_kwh') ? T('example_kwh') : '' } : null,
  }));
  const general = [];
  const e = v.electricity;
  if (e) {
    if (e.mode === 'flat_kwh') general.push({ label: T('electricity'), value: T('electricity_flat', { price: money(e.price), kwh: e.kwh_included }), per: '', sub: e.kwh_price != null ? T('electricity_over', { price: money(e.kwh_price) }) : '' });
    else general.push({ label: T('electricity'), value: money(e.price), per: T(e.mode === 'kwh' ? 'per_kwh' : 'per_night'), sub: '' });
  }
  if (v.tourist_tax) general.push({ label: T('tourist_tax'), value: money(v.tourist_tax.price), per: T('tourist_tax_per'), sub: v.tourist_tax.free_until != null ? T('tourist_tax_free', { n: v.tourist_tax.free_until }) : '' });
  const r = v.rules || {}, rules = [];
  if (r.min_nights > 1) rules.push(T('min_nights', { n: r.min_nights }));
  if (r.acsi) rules.push(T('acsi', { price: money(r.acsi) }));
  for (const x of r.long_stay || []) rules.push(T('long_stay', { n: x.nights, p: x.percent }));
  return {
    seasons, general, rules,
    included: v.services.included.map((k) => T('svc_' + k)),
    paid: v.services.paid.map((x) => ({ label: T('svc_' + x.key), value: x.price != null ? money(x.price) : T('on_request'), per: x.price != null && x.unit ? T('per_' + x.unit) : '' })),
  };
}

/** HTML zu describe() für App und öffentliche Seite (eine Quelle für beide). esc escapt jede Zeichenkette — auch
 *  Betreibertexte wie eigene Saison- und Platznamen. Ohne äußere Überschrift; die setzt der Aufrufer. */
function markup(d, { esc, t, note, stale = false }) {
  if (!d) return '';
  const T = (k, v) => esc(t('price.' + k, v));
  const list = (rows) => `<dl class="vc-prices-list">${rows.map((r) => `<div><dt>${esc(r.label)}${r.sub ? `<small>${esc(r.sub)}</small>` : ''}</dt><dd>${esc(r.value)}${r.per ? ` <small>${esc(r.per)}</small>` : ''}</dd></div>`).join('')}</dl>`;
  const ex = (e) => (e ? `<div class="vc-prices-example"><span>${esc(e.title)}</span><strong>${esc(e.total)}</strong><small>${esc(e.detail)}${e.note ? ' · ' + esc(e.note) : ''}</small></div>` : '');
  const head = (s) => `<span class="vc-prices-title">${esc(s.title)}</span>${s.current ? `<span class="vc-tag is-primary vc-prices-now">${T('now')}</span>` : ''}${s.ranges ? `<span class="vc-prices-ranges">${esc(s.ranges)}</span>` : ''}`;
  let out = '';
  if (d.seasons.length > 1) {
    out += d.seasons.map((s) => `<details class="vc-prices-season${s.current ? ' is-current' : ''}"${s.open ? ' open' : ''}><summary>${head(s)}<span class="vc-icon vc-prices-chev" aria-hidden="true">expand_more</span></summary>${list(s.rows)}${ex(s.example)}</details>`).join('');
  } else if (d.seasons.length) {
    const s = d.seasons[0];
    out += `<div class="vc-prices-season is-single"><h3 class="vc-prices-head">${head(s)}</h3>${list(s.rows)}${ex(s.example)}</div>`;
  }
  if (d.general.length) out += `<h3 class="vc-prices-sub">${T('general')}</h3>${list(d.general)}`;
  if (d.included.length) out += `<h3 class="vc-prices-sub">${T('included')}</h3><ul class="vc-prices-chips">${d.included.map((x) => `<li><span class="vc-icon" aria-hidden="true">check</span>${esc(x)}</li>`).join('')}</ul>`;
  if (d.paid.length) out += `<h3 class="vc-prices-sub">${T('paid')}</h3>${list(d.paid)}`;
  if (d.rules.length) out += `<h3 class="vc-prices-sub">${T('rules')}</h3><ul class="vc-prices-rules">${d.rules.map((x) => `<li>${esc(x)}</li>`).join('')}</ul>`;
  if (note) out += `<p class="vc-prices-note${stale ? ' is-stale' : ''}">${esc(note)}</p>`;
  return out;
}

/** Preisstand älter als 12 Monate? (updated = 'YYYY-MM-DD'; ohne Datum: unbekannt → false) */
const STALE_DAYS = 365;
function isStale(updated, now = new Date()) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(String(updated || ''))) return false;
  return (new Date(now).getTime() - new Date(updated + 'T12:00:00Z').getTime()) / 864e5 > STALE_DAYS;
}

export { SEASON_KINDS, PITCH_KINDS, ELECTRICITY_MODES, SERVICES, SERVICE_UNITS, ACSI_RATES, MAX, STALE_DAYS,
  validate, migrate, inSeason, seasonAt, example, template, seasonBar, view, describe, markup, isStale };
